import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useEffect, useState } from 'react';
import { artifactUrlCache } from '../../data/pack-store';
/**
 * Object URL for a pack entry (step screenshots). The ArtifactUrlCache OWNS
 * revocation — this hook never calls revokeObjectURL; a URL handed out here
 * stays valid until the cache evicts it (recency-refreshed by every getUrl,
 * so an on-screen image is never evicted in practice).
 */
export function useArtifactUrl(rel) {
  var _useState = useState({
      url: null,
      state: rel ? 'loading' : 'idle'
    }),
    _useState2 = _slicedToArray(_useState, 2),
    result = _useState2[0],
    setResult = _useState2[1];
  useEffect(function () {
    if (!rel) {
      setResult({
        url: null,
        state: 'idle'
      });
      return undefined;
    }
    var cache = artifactUrlCache();
    if (!cache) {
      // Pack is closing — the page is unmounting anyway.
      setResult({
        url: null,
        state: 'error'
      });
      return undefined;
    }
    var alive = true;
    setResult(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        state: 'loading'
      });
    });
    cache.getUrl(rel).then(function (url) {
      if (alive) setResult({
        url: url,
        state: url ? 'ready' : 'error'
      });
    })["catch"](function () {
      if (alive) setResult({
        url: null,
        state: 'error'
      });
    });
    return function () {
      alive = false;
    };
  }, [rel]);
  return result;
}